import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { gsap } from 'gsap';
import { isEqual, ScorecardDescription, ScorecardDisplayType } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
@Component({
  selector: 'fgbcl-scorecard-description-header',
  templateUrl: './scorecard-description-header.component.html',
  styleUrl: './scorecard-description-header.component.scss',
})
export class ScorecardDescriptionHeaderComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() scorecardDescription: ScorecardDescription;
  @Output() onPreviousClick: EventEmitter<any> = new EventEmitter();
  @Output() onNextClick: EventEmitter<any> = new EventEmitter();
  @Input() isSponsorInBody: boolean = false;
  @ViewChild('track', { static: false, read: ElementRef }) track: ElementRef;
  currentPosition: number = -1;
  containerWidth: number = 320;
  itemWidth = 100;
  itemGap = 10;
  offset: number = 0;

  constructor(
    private offcanvasService: NgbOffcanvas,
    private location: Location
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.scorecardDescription &&
      !isEqual(changes.scorecardDescription.currentValue, changes.scorecardDescription.previousValue) &&
      changes.scorecardDescription.previousValue !== undefined
    ) {
      this.currentPosition = changes.scorecardDescription.currentValue.currentScorecardIndex;
      this.offset = this.getOffset(this.currentPosition);
      this.animateCarousel();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scorecardDescription.showLinkedScoreCard && (this.currentPosition = this.scorecardDescription.currentScorecardIndex);
    });
    this._initCarouselPosition();
  }

  private _initCarouselPosition() {
    this.offset = this.getOffset(this.scorecardDescription.currentScorecardIndex);
    gsap.set(this.track.nativeElement, {
      x: this.offset,
    });
  }

  setSelected(index: number) {
    if (this.currentPosition === index || !this.scorecardDescription?.showLinkedScoreCard) return;
    if (index < this.currentPosition) {
      this.onPreviousClick.emit();
    } else if (index > this.currentPosition) {
      this.onNextClick.emit();
    }
    this.currentPosition = index;
    this.offset = this.getOffset(index);
    this.animateCarousel();
  }

  private getOffset(index: number) {
    return this.containerWidth / 2 - this.itemWidth / 2 - index * (this.itemWidth + this.itemGap);
  }

  private animateCarousel() {
    const allItems = this.track.nativeElement.querySelectorAll('.scorecard-img-carousel-item');
    gsap.to(allItems, {
      scale: 1,
      duration: 0.3,
      ease: 'power2.inOut',
    });
    gsap.to(this.track.nativeElement, {
      x: this.offset,
      duration: 0.5,
      ease: 'power2.out',
      onStart: () => {
        const selectedElem = this.track.nativeElement.querySelector('.selected');
        if (selectedElem) {
          gsap.fromTo(selectedElem, { scale: 1 }, { scale: 1.5, duration: 0.3, ease: 'power2.out' });
        }
      },
    });
  }

  back() {
    this.location.back();
  }

  closeModal(): void {
    this.offcanvasService.dismiss();
  }

  get isLast() {
    return this.scorecardDescription.linkedScorecardLength === this.scorecardDescription.currentScorecardIndex + 1;
  }

  get isFirst() {
    return this.scorecardDescription.currentScorecardIndex === 0;
  }

  get hasPrizeSelection(): boolean {
    return !!this.scorecardDescription.currentScorecard?.PrizeOptions;
  }

  get isStreakView(): boolean {
    return this.scorecardDescription.currentScorecard?.ScoreCardDisplayType === ScorecardDisplayType.streakView;
  }
}
